import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import { Popper as ReactPopper } from 'react-popper';


export { Manager, Reference } from 'react-popper';

var getFlipBehavior = function getFlipBehavior(side) {
  return {
    auto: [],
    top: ['top', 'bottom', 'top'],
    right: ['right', 'left', 'right'],
    bottom: ['bottom', 'top', 'bottom'],
    left: ['left', 'right', 'left']
  }[side];
};

export var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || _Object$getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.getModifiers = memoizeOne(function (placement) {
      var flipBehavior = getFlipBehavior(placement.split('-')[0]);
      var modifiers = {
        flip: {
          enabled: true,
          behavior: flipBehavior,
          boundariesElement: 'viewport'
        },
        hide: {
          enabled: true,
          boundariesElement: 'scrollParent'
        },
        offset: {
          enabled: true,
          offset: _this.props.offset
        },
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
          boundariesElement: 'window'
        }
      };

      return modifiers;
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          placement = _props.placement,
          children = _props.children;

      var modifiers = this.getModifiers(this.props.placement);

      return React.createElement(
        ReactPopper,
        { positionFixed: true, modifiers: modifiers, placement: placement },
        children
      );
    }
  }]);

  return Popper;
}(Component);
Popper.defaultProps = {
  children: function children() {},
  offset: '0 8px',
  placement: 'bottom-start'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/popper/dist/esm/Popper.js
// module id = 1230
// module chunks = 0